// PurchaseOrderItem Component

/* eslint indent: 0, react/jsx-indent: 0 */

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import PriceText from '../../../common/common/price_text/price_text.jsx'
import Util from '../../../lib/util.jsx'

class PurchaseOrderItem extends Component {
  static get propTypes () {
    return {
      purchaseOrder: PropTypes.object,
      onSetting: PropTypes.func,
      onView: PropTypes.func,
      onDownload: PropTypes.func,
      downloadUrl: PropTypes.string,
      showProjectNumber: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      purchaseOrder: null,
      onSetting: null,
      onView: null,
      onDownload: null,
      downloadUrl: '',
      showProjectNumber: false
    }
  }

  render () {
    const purchaseOrder = this.props.purchaseOrder
    const _className = classnames(
      'purchaseorder-item',
      {},
      `purchaseorder-item_${purchaseOrder.status.toLowerCase()}`
    )
    const _classDate =
      purchaseOrder.status === 'Closed' ? 'coldate year' : 'coldate'
    const date = new Date(purchaseOrder.invoiceDate)
    const status = Util.getTranslatedStatus(purchaseOrder.status)
    const showProjectNumber = this.props.showProjectNumber

    return (
      <div className={_className} onClick={this._onView.bind(this)}>
        <div className='progress' />
        <div className={_classDate}>
          <div className='month'>{DateUtil.getDisplayMonth(date)}</div>
          <div className='day'>{DateUtil.getDisplayDay(date)}</div>
          {purchaseOrder.status === 'Closed' && (
            <div className='year'>{DateUtil.getDisplayYear(date)}</div>
          )}
        </div>
        <div className='colsplit' />
        <div className='colinner'>
          <h4 className='title'>
            {purchaseOrder &&
            purchaseOrder.contact &&
            purchaseOrder.contact.company
              ? purchaseOrder.contact.company
              : ''}
          </h4>
          <div className='info'>
            <IconButton
              icon='list-attachment'
              size='normal'
              canHover
              onClick={this._onDownload.bind(this)}
              target='_blank'
              href={encodeURI(`${this.props.downloadUrl}`)}
              className='subcriptioninfo'
              tooltip='expense.list.tipAttachment'
              tooltipPosition='top'
            />
            <div className='title'>{purchaseOrder.invoiceNo}</div>
            <div className='split' />
            {purchaseOrder.projectId &&
            purchaseOrder.project &&
            purchaseOrder.project.title ? (
              <div className='project'>
                {(showProjectNumber
                  ? `${purchaseOrder.project.projectNumber || '-'} / `
                  : '') + `${purchaseOrder.project.title}`}
              </div>
            ) : (
              ''
            )}
            {purchaseOrder.projectId &&
              purchaseOrder.project &&
              purchaseOrder.project.title && <div className='split' />}
            <div className='status'>
              <IntlMessage ident={status} />
            </div>
          </div>
        </div>
        <div className='colsplit' />
        <div className='coltotal'>
          <h2 className='amount'>
            <span className='value'>
              <PriceText value={purchaseOrder.total} />
            </span>
          </h2>
          {this._renderRemainingPoAmount()}
        </div>
        <IconButton
          title='expense.list.titleSettings'
          icon='common-action-setting'
          size='small'
          onClick={this._onSetting.bind(this)}
        />
      </div>
    )
  }

  /* Event Handlers */
  _onView (e) {
    e.preventDefault()

    if (this.props.onView) {
      this.props.onView(this.props.purchaseOrder)
    }
  }

  _onSetting (e) {
    e.preventDefault()
    e.stopPropagation()

    if (this.props.onSetting) {
      this.props.onSetting(this.props.purchaseOrder)
    }
  }

  _onDownload (e) {
    e.stopPropagation()
  }

  _renderRemainingPoAmount () {
    const purchaseOrder = this.props.purchaseOrder

    if (purchaseOrder.remainingPO) {
      return (
        <div className='expense'>
          <span className='label'>
            <IntlMessage ident='purchaseOrder.form.openPOAmount' />
          </span>
          <div className='cost'>
            <span>
              <PriceText value={purchaseOrder.remainingPO} />
            </span>
          </div>
        </div>
      )
    }

    return ''
  }
}

export default PurchaseOrderItem
